export type PositionToTrigger = 'after' | 'overlap';

export type HDirection = 'left' | 'right';
export type VDirection = 'top' | 'bottom';

type Coordinate = {
  x: number;
  y: number;
};

const OVERLAP_OFFSET = -4;

type PopoverPositionProps = {
  left: number;
  top: number;
  hDirection: HDirection;
  vDirection: VDirection;
};

export function getPopoverPositionProps(
  anchorRect: DOMRect,
  positionToTrigger: PositionToTrigger,
  contentRect: DOMRect,
  cursorCoordinate: Coordinate,
  withAnchor: boolean,
  hDirection: HDirection | undefined,
  vDirection: VDirection | undefined,
): PopoverPositionProps {
  const { innerHeight, innerWidth } = window;
  let targetLeft: number | undefined;
  let targetTop: number | undefined;
  const {
    top: triggerTop,
    left: triggerLeft,
    right: triggerRight,
    bottom: triggerBottom,
  } = anchorRect;
  let gapBelow = 0;
  let gapRight = 0;

  switch (positionToTrigger) {
    case 'after':
      gapBelow = innerHeight - cursorCoordinate.y;
      gapRight = innerWidth - cursorCoordinate.x;
      break;
    case 'overlap':
      gapBelow = innerHeight - triggerBottom;
      gapRight = innerWidth - triggerRight;
      break;
    default:
      break;
  }

  const { width: contentWidth, height: contentHeight } = contentRect;
  const horizontalDirection =
    hDirection ?? (gapRight > contentWidth ? 'right' : 'left');
  const verticalDirection =
    vDirection ?? (gapBelow > contentHeight ? 'bottom' : 'top');
  if (withAnchor) {
    switch (positionToTrigger) {
      case 'after':
        targetLeft =
          horizontalDirection === 'right' ? triggerLeft : triggerRight;
        targetTop =
          verticalDirection === 'bottom' ? triggerBottom + 5 : triggerTop - 5;
        break;
      case 'overlap':
        targetLeft =
          horizontalDirection === 'right'
            ? triggerRight + OVERLAP_OFFSET
            : triggerLeft - OVERLAP_OFFSET;
        targetTop = verticalDirection === 'bottom' ? triggerTop : triggerBottom;
        break;
      default:
        break;
    }
  }
  let positionLeft = targetLeft ?? cursorCoordinate.x;
  let positionTop = targetTop ?? cursorCoordinate.y;

  if (horizontalDirection === 'left' && contentWidth > positionLeft - 10) {
    positionLeft = contentWidth + 10;
  }
  if (verticalDirection === 'top' && contentHeight > positionTop - 10) {
    positionTop = contentHeight + 10;
  }

  return {
    left: positionLeft,
    top: positionTop,
    hDirection: horizontalDirection,
    vDirection: verticalDirection,
  };
}
